module.exports = __webpack_public_path__ + "static/media/health-medical-insurance-near-you.53094376.jpg";